import React from 'react'
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import FileCopyIcon from '@material-ui/icons/FileCopy'
import NextWeekIcon from '@material-ui/icons/NextWeek';
import NextWeekOutlinedIcon from '@material-ui/icons/NextWeekOutlined';
import NextWeekTwoToneIcon from '@material-ui/icons/NextWeekTwoTone';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import FeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList';
import SecurityIcon from '@material-ui/icons/Security';
import DashboardIcon from '@material-ui/icons/Dashboard';
import NfcRoundedIcon from '@material-ui/icons/NfcRounded';
import SettingsRoundedIcon from '@material-ui/icons/SettingsRounded';
import PeopleOutlineRoundedIcon from '@material-ui/icons/PeopleOutlineRounded';
import WidgetsIcon from '@material-ui/icons/Widgets';


export const RoutesInterfaceNavigations = [
    {
        title: 'Dashboard',
        href: '/dashboard',
        icon: <DashboardIcon/>
    },
    {
        title: 'Clients',
        href: '/clients',
        icon:  <PeopleOutlineRoundedIcon/>
    },
    {
        title: 'Products',
        href: '/products',
        icon:  <NfcRoundedIcon/>
    },
    {
        title: 'customers',
        href: '/customers',
        icon:  <ContactPhoneIcon/>
    },
    {
        title: 'Stake Holders',
        href: '/stakeholders',
        icon:  <NextWeekIcon/>
    },
    {
        title: 'Stake Holder view',
        href: '/stakeholder/view/9105',
        icon:  <NextWeekOutlinedIcon/>
    },
    {
        title: 'Stake Holder edit',
        href: '/stakeholder/edit/9105',
        icon:  <NextWeekTwoToneIcon/>
    },
    {
        title: 'Formik Form',
        href: '/formik-form',
        icon:  <FileCopyIcon/>
    },
    {
        title: 'Settings- Nested',
        href: '/settings',
        icon:  <SettingsRoundedIcon/>
    },
    {
        title: 'Ui Components',
        href: '/components',
        icon:  <WidgetsIcon/>,
        child: [
            {
                title: 'alerts',
                href: '/components/alerts',
                icon:  <ArrowRightIcon/>,
            },
            {
                title: 'appbar',
                href: '/components/appbar',
                icon:  <ArrowRightIcon/>,
            },
            {
                title: 'modal-dialog',
                href: '/components/modal-dialog',
                icon:  <ArrowRightIcon/>,
            },
            {
                title: 'buttons',
                href: '/components/buttons',
                icon:  <ArrowRightIcon/>,
            },
            {
                title: 'checkboxes',
                href: '/components/checkboxes',
                icon:  <ArrowRightIcon/>,
            },
            {
                title: 'icons',
                href: '/components/icons',
                icon:  <ArrowRightIcon/>,
            },
            {
                title: 'progress',
                href: '/components/progress',
                icon:  <ArrowRightIcon/>,
            },
            {
                title: 'expansion',
                href: '/components/expansion',
                icon:  <ArrowRightIcon/>,
            },
            {
                title: 'snackbar',
                href: '/components/snackbar',
                icon:  <ArrowRightIcon/>,
            },
            {
                title: 'switches',
                href: '/components/switches',
                icon:  <ArrowRightIcon/>,
            },
            {
                title: 'sliders',
                href: '/components/sliders',
                icon:  <ArrowRightIcon/>,
            },
            {
                title: 'Radio buttons',
                href: '/components/radio-buttons',
                icon:  <ArrowRightIcon/>,
            }
        ],
        openState: false//nav status open/close
    },
    {
        title: 'layout2 pages',
        href: '/layout2',
        icon:  <FeaturedPlayListIcon/>,
        child:[
            {
                title: 'Not found',
                href: '/not-found',
                icon:  <WidgetsIcon/>,
            },
            {
                title: 'internal error',
                href: '/internal-error',
                icon:  <WidgetsIcon/>,
            }
        ],
        openState: false
    },
    {
        title: 'layout3 pages',
        href: '/layout3',
        icon:  <SecurityIcon/>,
        child:[
            {
                title: 'SignIn',
                href: '/signin',
                icon:  <LockOpenIcon/>,
            },
            {
                title: 'SignUp',
                href: '/signUp',
                icon:  <VpnKeyIcon/>,
            },
            {
                title: 'Forgot Password',
                href: '/forgot-password',
                icon:  <LinkOffIcon/>,
            }
        ],
        openState: false
    }
    
]